import { useLanguage } from '../contexts/LanguageContext';

export function Partners() {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('partners_title') || 'Our Partners'}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center justify-items-center">
          <div className="flex flex-col items-center p-6 rounded-lg hover:bg-gray-50 transition-colors">
            <img 
              src="/assets/isola_logo.jpg" 
              alt="ISOLA Logo" 
              className="h-24 w-auto object-contain mb-4"
            />
          
          </div>
          
          <div className="flex flex-col items-center p-6 rounded-lg hover:bg-gray-50 transition-colors">
            <img 
              src="/assets/vist_logo.png" 
              alt="VIST Logo" 
              className="h-24 w-auto object-contain mb-4"
            />
          </div>
          
          <div className="flex flex-col items-center p-6 rounded-lg hover:bg-gray-50 transition-colors">
            <img 
              src="/assets/academia_logo.png" 
              alt="Academia Logo" 
              className="h-24 w-auto object-contain mb-4"
            />
            
          </div>
        </div>
      </div>
    </section>
  );
}
